(function () {
  if (window.HBCartUpsell) return;

  var RECENT_ADD_KEY = 'hb_cart_upsell_recent_add';
  var RECENT_ADD_WINDOW = 10 * 60 * 1000;
  var TRACKING_SOURCE = 'cart_drawer';
  var observedUpsells = new WeakSet();
  var trackedImpressions = new Set();
  var visibilityRevision = 0;
  var promoTargets = new Set();
  var observedCartDrawer = null;
  var cartDrawerObserver = null;
  var promoDomObserver = null;
  var promoLayerSyncQueued = false;

  function ensurePromoLayerStyle() {
    if (document.getElementById('hb-cart-promo-layer-style')) return;
    var style = document.createElement('style');
    style.id = 'hb-cart-promo-layer-style';
    style.textContent = [
      '@media (max-width: 767px) {',
      '  [data-hb-cart-promo-teaser][data-hb-cart-promo-suppressed="true"] {',
      '    opacity: 0 !important;',
      '    visibility: hidden !important;',
      '    pointer-events: none !important;',
      '  }',
      '}'
    ].join('\n');
    document.head.appendChild(style);
  }

  function promoButtonLabel(button) {
    return String(button.textContent || button.getAttribute('aria-label') || '')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function findPromoTarget(button) {
    var element = button;
    while (element && element !== document.body) {
      if (window.getComputedStyle(element).position === 'fixed') return element;
      element = element.parentElement;
    }
    return button;
  }

  function discoverPromoTargets() {
    document.querySelectorAll('button').forEach(function (button) {
      if (!/^GET\s*10%\s*OFF!?$/i.test(promoButtonLabel(button))) return;
      var target = findPromoTarget(button);
      target.setAttribute('data-hb-cart-promo-teaser', 'true');
      promoTargets.add(target);
    });
  }

  function isMobileCartOpen() {
    var isMobile = window.matchMedia
      ? window.matchMedia('(max-width: 767px)').matches
      : window.innerWidth <= 767;
    if (!isMobile) return false;

    var drawer = document.getElementById('CartDrawer');
    if (!drawer || !drawer.isConnected) return false;
    var drawerStyle = window.getComputedStyle(drawer);
    if (drawerStyle.display === 'none' || drawerStyle.visibility === 'hidden') return false;

    var dialog = drawer.querySelector('#update-cart, [role="dialog"]');
    if (dialog) {
      var dialogStyle = window.getComputedStyle(dialog);
      if (dialogStyle.display === 'none' || dialogStyle.visibility === 'hidden') return false;
    }
    return drawer.getClientRects().length > 0;
  }

  function observeCartDrawer() {
    var drawer = document.getElementById('CartDrawer');
    if (drawer === observedCartDrawer) return;
    if (cartDrawerObserver) cartDrawerObserver.disconnect();
    observedCartDrawer = drawer;
    cartDrawerObserver = null;

    if (!drawer || !('MutationObserver' in window)) return;
    cartDrawerObserver = new MutationObserver(schedulePromoLayerSync);
    cartDrawerObserver.observe(drawer, {
      attributes: true,
      attributeFilter: ['style', 'class', 'aria-hidden'],
      subtree: true
    });
  }

  function syncPromoLayer() {
    ensurePromoLayerStyle();
    discoverPromoTargets();
    observeCartDrawer();
    var suppress = isMobileCartOpen();

    promoTargets.forEach(function (target) {
      if (!target.isConnected) {
        promoTargets.delete(target);
        return;
      }
      if (suppress) target.setAttribute('data-hb-cart-promo-suppressed', 'true');
      else target.removeAttribute('data-hb-cart-promo-suppressed');
    });
  }

  function schedulePromoLayerSync() {
    if (promoLayerSyncQueued) return;
    promoLayerSyncQueued = true;
    var schedule = window.requestAnimationFrame || window.setTimeout;
    schedule(function () {
      promoLayerSyncQueued = false;
      syncPromoLayer();
    });
  }

  function initPromoLayerInterlock() {
    if (!document.body || !document.head || typeof document.createElement !== 'function'
      || typeof window.getComputedStyle !== 'function') return;
    syncPromoLayer();
    if ('MutationObserver' in window) {
      promoDomObserver = new MutationObserver(schedulePromoLayerSync);
      promoDomObserver.observe(document.body, { childList: true, subtree: true });
    }
    window.addEventListener('resize', schedulePromoLayerSync, { passive: true });
    document.addEventListener('click', schedulePromoLayerSync, true);
    document.addEventListener('touchstart', schedulePromoLayerSync, { capture: true, passive: true });
  }

  function analyticsPayload(container, detail) {
    var price = Number(container && container.getAttribute('data-variant-price')) || 0;
    return Object.assign({
      source: TRACKING_SOURCE,
      profile: container ? container.getAttribute('data-profile') || 'seasonal' : 'seasonal',
      product_id: container ? container.getAttribute('data-product-id') || '' : '',
      product_handle: container ? container.getAttribute('data-product-handle') || '' : '',
      product_title: container ? container.getAttribute('data-product-title') || '' : '',
      variant_id: container ? container.getAttribute('data-variant-id') || '' : '',
      variant_title: container ? container.getAttribute('data-variant-title') || '' : '',
      value: price / 100,
      currency: container ? container.getAttribute('data-currency') || 'GBP' : 'GBP'
    }, detail || {});
  }

  function track(eventName, container, detail) {
    var payload = analyticsPayload(container, detail);
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(Object.assign({ event: eventName }, payload));

    try {
      if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
        window.Shopify.analytics.publish(eventName, payload);
      }
    } catch (error) {
      // dataLayer and order attribution remain available if a pixel rejects a custom event.
    }

    if (typeof window.clarity === 'function') window.clarity('event', eventName);
  }

  function trackImpression(container) {
    if (!container || container.hidden) return;
    var key = [
      container.getAttribute('data-profile') || 'seasonal',
      container.getAttribute('data-variant-id') || ''
    ].join(':');
    if (trackedImpressions.has(key)) return;
    trackedImpressions.add(key);
    track('hb_cart_upsell_impression', container);
  }

  var impressionObserver = 'IntersectionObserver' in window
    ? new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting || entry.intersectionRatio < 0.5) return;
        impressionObserver.unobserve(entry.target);
        trackImpression(entry.target);
      });
    }, { threshold: [0.5] })
    : null;

  function observeImpressions() {
    document.querySelectorAll('[data-hb-cart-upsell]').forEach(function (container) {
      if (container.hidden || observedUpsells.has(container)) return;
      observedUpsells.add(container);
      if (impressionObserver) impressionObserver.observe(container);
      else trackImpression(container);
    });
  }

  function getRecentAdd() {
    try {
      return Number(window.sessionStorage.getItem(RECENT_ADD_KEY) || 0);
    } catch (error) {
      return 0;
    }
  }

  function rememberAdd() {
    try {
      window.sessionStorage.setItem(RECENT_ADD_KEY, String(Date.now()));
    } catch (error) {
      // The recommendation still works when session storage is unavailable.
    }
  }

  function forgetRecentAdd() {
    try {
      window.sessionStorage.removeItem(RECENT_ADD_KEY);
    } catch (error) {
      // The recommendation still works when session storage is unavailable.
    }
  }

  function cartContainsAttributedUpsell(cart) {
    return Array.isArray(cart && cart.items) && cart.items.some(function (item) {
      return item.properties && item.properties._hb_upsell_source === TRACKING_SOURCE;
    });
  }

  function setVisibility(hidden) {
    document.querySelectorAll('[data-hb-cart-upsell]').forEach(function (element) {
      element.hidden = hidden;
    });
    observeImpressions();
  }

  async function syncVisibility(cart) {
    var revision = ++visibilityRevision;
    var hideRecent = Date.now() - getRecentAdd() < RECENT_ADD_WINDOW;
    setVisibility(hideRecent);
    if (!hideRecent) return;

    try {
      var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root
        ? window.Shopify.routes.root
        : '/';
      var currentCart = cart || await getCart(root);
      if (revision !== visibilityRevision) return;
      if (!cartContainsAttributedUpsell(currentCart)) {
        forgetRecentAdd();
        setVisibility(false);
      }
    } catch (error) {
      // Keep the recent-add state when the cart cannot be confirmed.
    }
  }

  function getSections() {
    try {
      var helper = window.Alpine && window.Alpine.store('xCartHelper');
      return helper && typeof helper.getSectionsToRender === 'function'
        ? helper.getSectionsToRender()
        : [];
    } catch (error) {
      return [];
    }
  }

  function refreshSections(payload, sections) {
    var result = { updatedCount: 0, cartContentUpdated: false };
    if (!payload.sections || !sections.length) return result;

    sections.forEach(function (section) {
      var sectionElement = document.querySelector(section.selector);
      var sectionHtml = payload.sections[section.id];
      if (!sectionElement || !sectionHtml) return;

      if (typeof window.getSectionInnerHTML === 'function') {
        var innerHtml = window.getSectionInnerHTML(sectionHtml, section.selector);
        if (typeof innerHtml !== 'string') return;
        sectionElement.innerHTML = innerHtml;
      } else {
        var parsed = new DOMParser().parseFromString(sectionHtml, 'text/html');
        var replacement = parsed.querySelector(section.selector);
        if (!replacement) return;
        sectionElement.innerHTML = replacement.innerHTML;
      }

      result.updatedCount += 1;
      if (section.selector === '#CartDrawer' || section.selector === '#main-cart-items') {
        result.cartContentUpdated = true;
      }
    });

    return result;
  }

  async function getCart(root) {
    var response = await fetch(root + 'cart.js', {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' },
      cache: 'no-store'
    });
    if (!response.ok) throw new Error('Your basket could not be confirmed. Please try again.');
    return response.json();
  }

  function cartContainsVariant(cart, variantId) {
    return Array.isArray(cart.items) && cart.items.some(function (item) {
      return Number(item.variant_id || item.id) === variantId;
    });
  }

  function updateCartCount(cart) {
    var displayCount = cart.item_count > 99 ? '99+' : String(cart.item_count);
    ['#cart-icon-bubble', '#mobile-cart-icon-bubble'].forEach(function (selector) {
      document.querySelectorAll(selector).forEach(function (bubble) {
        var count = bubble.querySelector('span');
        var badge = bubble.firstElementChild;
        if (count) count.textContent = displayCount;
        if (badge) badge.classList.toggle('hidden', cart.item_count === 0);
        bubble.setAttribute('data-value', String(cart.item_count));
      });
    });

    try {
      var helper = window.Alpine && window.Alpine.store('xCartHelper');
      if (helper) helper.currentItemCount = cart.item_count;
    } catch (error) {
      // The visible count is already updated; Alpine will reconcile on its next cart event.
    }
  }

  function reloadMiniCart() {
    try {
      var miniCart = window.Alpine && window.Alpine.store('xMiniCart');
      if (!miniCart || typeof miniCart.reLoad !== 'function') return false;
      miniCart.reLoad();
      return true;
    } catch (error) {
      return false;
    }
  }

  function showAddedState(container, button, status) {
    container.classList.remove('is-loading');
    container.classList.add('is-added');
    var label = button.querySelector('[data-hb-cart-upsell-label]');
    if (label) label.textContent = 'Added';
    if (status) {
      status.textContent = 'Added to your basket.';
      status.classList.add('is-success');
    }
  }

  async function addUpsell(button) {
    var container = button.closest('[data-hb-cart-upsell]');
    var status = container && container.querySelector('[data-hb-cart-upsell-status]');
    var variantId = Number(button.getAttribute('data-variant-id'));
    if (!container || !variantId || button.disabled) return;

    button.disabled = true;
    container.classList.add('is-loading');
    if (status) status.textContent = '';

    var sections = getSections();
    var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      ? window.Shopify.routes.root
      : '/';
    var attribution = analyticsPayload(container);

    try {
      var response = await fetch(root + 'cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({
          items: [{
            id: variantId,
            quantity: 1,
            properties: {
              _hb_upsell_source: TRACKING_SOURCE,
              _hb_upsell_profile: attribution.profile,
              _hb_upsell_product_handle: attribution.product_handle
            }
          }],
          sections: sections.map(function (section) { return section.id; }),
          sections_url: window.location.pathname
        })
      });
      var payload = await response.json();
      if (!response.ok || payload.status === 422) {
        throw new Error(payload.description || 'This item could not be added. Please try again.');
      }

      var cart = await getCart(root);
      if (!cartContainsVariant(cart, variantId)) {
        throw new Error('This item was not found in your basket. Please try again.');
      }

      var refreshResult = refreshSections(payload, sections);
      updateCartCount(cart);

      if (refreshResult.cartContentUpdated) {
        rememberAdd();
        syncVisibility(cart);
      } else {
        showAddedState(container, button, status);
        reloadMiniCart();
        window.setTimeout(function () {
          rememberAdd();
          syncVisibility(cart);
        }, 1200);
      }

      document.dispatchEvent(new CustomEvent('eurus:cart:items-changed'));
      document.dispatchEvent(new CustomEvent('hb:cart-upsell-added', {
        detail: Object.assign({ variantId: variantId }, attribution)
      }));
      track('hb_cart_upsell_add', container, { cart_item_count: cart.item_count });
    } catch (error) {
      button.disabled = false;
      container.classList.remove('is-loading');
      if (status) status.textContent = error.message || 'This item could not be added. Please try again.';
      track('hb_cart_upsell_add_error', container, {
        error_message: String(error && error.message ? error.message : 'unknown').slice(0, 160)
      });
      console.error('[HB cart upsell] Add failed:', error);
    }
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-hb-cart-upsell-add]');
    if (button) {
      event.preventDefault();
      var container = button.closest('[data-hb-cart-upsell]');
      track('hb_cart_upsell_click', container);
      addUpsell(button);
      return;
    }

    var productLink = event.target.closest('[data-hb-cart-upsell-product-link]');
    if (!productLink) return;
    track('hb_cart_upsell_product_opened', productLink.closest('[data-hb-cart-upsell]'));
  });

  document.addEventListener('eurus:cart:items-changed', function () {
    window.setTimeout(syncVisibility, 0);
    schedulePromoLayerSync();
  });

  window.HBCartUpsell = {
    syncVisibility: syncVisibility,
    syncPromoLayer: syncPromoLayer,
    isMobileCartOpen: isMobileCartOpen,
    track: track,
    clearRecentAdd: function () {
      forgetRecentAdd();
      syncVisibility();
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      syncVisibility();
      initPromoLayerInterlock();
    }, { once: true });
  } else {
    syncVisibility();
    initPromoLayerInterlock();
  }
})();
